import React from 'react';
import PublicPage from '../cms/PublicPage';

export default function ParentLoginPage() {
  return <PublicPage slug="parent-login" />;
}
